export default class Event {
    constructor(val) {
        this.that = val
    }

    send(title, data={}) {
        // regBtn loginBtn logoutBtn forgotBtn changeLang linkMail linkChat linkTg linkWa 
        // authDo authSuccess regDo regSuccess regFillSkip regFillSent | forgotPass 
        // transferGetPaySysChosen transferSendPaySysChosen transferCreate transferCreateReg transferPaymentBtn transferPaymentSuccess transferConfirm transferSuccess transferCancel requestSent
        // clientsClick partnerClick merchantClick investClick 
        // partnerJoin partnerConfirm partnerSuccess
        // vcardJoin vcardConfirm vcardSuccess
        // merchantJoin merchantConfirm merchantSuccess

        // console.log('sendEvent', title, data)

        // facebook
        try{
            const fbParams = {
                event_name: (data && data.event_name) ? data.event_name : null,
                event_id:   (data && data.event_id) ? data.event_id : null,
                action_source: 'website',
                event_time: (data && data.event_time) ? data.event_time : Math.floor(Date.now() / 1000),
                user_data: {
                    external_id: (data && data.user_data && data.user_data.external_id ) ? data.user_data.external_id : null,
                    fbc: (data && data.user_data && data.user_data.fbc) ? data.user_data.fbc : null,
                    fbp: (data && data.user_data && data.user_data.fbp) ? data.user_data.fbp : null,
                    client_user_agent: (data && data.user_data && data.user_data.client_user_agent) ? data.user_data.client_user_agent : null,
                    subscription_id: (data && data.user_data && data.user_data.subscription_id) ? data.user_data.subscription_id : null,
                    // client_ip_address: (data && data.client_ip_address) ? data.client_ip_address : null,
                },
                // пока без данных о заказе
                custom_data: null,
                event_source_url: (data.event_source_url) ? data.event_source_url : window.location.href,
            }
            if(window.fbq) {
                window.fbq('trackCustom', title, fbParams)
            }
            
        } catch (e) {
            console.log('fbq error', e)
        }

        // GTM
        try{
            if(this.that.$gtm) {
                this.that.$gtm.trackEvent({
                    event: title,
                    category: 'event',
                    action: 'action',
                    label: title,
                    value: 1,
                    noninteraction: false, // Optional
                })
            }
        } catch{}

        //yandex
        try{
            if(this.that.$yandexMetrika){
                switch (title){
                    case 'transferGetPaySysChosen':
                    case 'transferSendPaySysChosen':
                        this.that.$yandexMetrika.reachGoal(title, {currency: data.custom_data})
                        break;
                    default:
                        this.that.$yandexMetrika.reachGoal(title)
                        break;
                }
            }
        } catch {
            
        }

        // MAILRU
        try{
            _tmr.push({ type: 'reachGoal', id: 3414732, goal: title});
        } catch{

        }
        return;
    }

}